import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DateTimePicker} from '@mui/x-date-pickers';
import {TextField} from "@mui/material";

const DateTimeInput = ({value, setValue, helperText, variant}) => {
    const handleDateTimeChange = (newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ru'>
                <DateTimePicker
                    size="small"
                    value={value}
                    onChange={handleDateTimeChange}
                    sx={{
                        "& .MuiInputBase-root": {
                            height: '43px'
                        }
                    }}
                    ampm={false}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            helperText={helperText ? helperText : null}
                            size="small"
                            variant={variant ? variant : 'standard'}
                        />
                    )}
                    inputFormat="DD/MM/YYYY HH:mm"
                />
            </LocalizationProvider>
        </div>
    );
};

export default DateTimeInput;